import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RoleRoute({ children, allowed }) {
  const { userdata } = useAuth();

  if (!userdata) return <Navigate to="/" />;
  if (!allowed.includes(userdata.role)) return <Navigate to="/" />;

  return children;
}
